import { Component, OnInit, Input } from "@angular/core";
import { SieniService } from "../../services/sieni.service";
import { MModuleEvaluation } from "../../models/module-evaluation.model";
import { TranslateService } from "@ngx-translate/core";
import { Alert } from "../../models/alert.model";
import { MReportType } from "../../models/report-type.model";

@Component({
  selector: "report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.scss"]
})
export class ReportComponent implements OnInit {
  @Input("evaluationInfo") public evaluationInfo: MModuleEvaluation = null;
  @Input("reportTypes") public reportTypes: MReportType[] = [];
  public gettingReport: boolean = false;
  public reportUrl: string = "";
  constructor(
    private sieniService: SieniService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    // console.log(this.evaluationInfo);
    // console.log(this.reportTypes);
    // this.sieniService
    //   .getReportTypes()
    //   .subscribe(resp => (this.reportTypes = resp));
  }

  public getReport() {
    if (this.reportUrl !== "") {
      this.gettingReport = true;
      let url = this.reportUrl
        .replace("{toolbox_id}", `1`)
        .replace("{id}", `${this.evaluationInfo.id}`);
      this.sieniService.getReport(url).subscribe(
        (res: any) => {
          var file = new Blob([res], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.gettingReport = false;
        },
        err => {
          if (err.status === 404)
            Alert.buildErrorAlert(this.translate.instant("history.alert.404"));
          else
            Alert.buildErrorAlert(
              this.translate.instant("history.alert.error")
            );
          this.gettingReport = false;
        }
      );
    }
  }
}
